import Vue from 'vue'
import Vuex from 'vuex'
// import { stat } from 'fs';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		status: "Tube",
		userStatus:"offline",
		userName:'',
		userMail:'',
		UID:0,
		userPasswd:'',
		unRead: false,
		lastSyncDatetime:'',
		nowTitle:'',
		sideBarOpen:false,
		searchPageModalOpen:false,
		showSearchPageCreateGroup:false,
		chatPageModalOpen:false,
		baseUrl:'https://chat.seasideworkshop.net/api',
		// prevRoute:'',
		chats: [ // Array that stores info about all groups.
			// cid: 
			// title:
			// des:
			// lastestMessage:
			// updateDate:
			// lastUpdateDatetime:
			// messageCount:
			// muted:
			// history:
			// { 
			// 	cid: 1, 
			// 	title: 'try1',
			// 	des: "2019-07-17 15:51:02",
			// 	lastestMessage: 'user1: yep',
			// 	updateDate: '16:36',
			// 	lastUpdateDatetime:'2019-05-25 16:36:13',
			// 	messageCount: 10,
			// 	muted: false,
			// 	history:[
			// 		{userName:'1',message:'chat 1 stands by',date:'2019-6-1',type:'msg',errorMsg:false,sentUserUid:1},
			// 		{userName:'2',message:'and',date:'2019-6-2',type:'msg',errorMsg:true,sentUserUid:2},
			// 		{userName:'3',message:'die',date:'2019-05-25 16:38:13',type:'msg',errorMsg:false,sentUserUid:3}
			// 	]
			// },
			// { 
			// 	cid: 2, 
			// 	title: 'try2',
			// 	lastestMessage: 'panda2: nope',
			// 	updateDate: '21:02',
			// 	lastUpdateDatetime:'2019-05-25 16:36:13',
			// 	messageCount: 24,
			// 	muted: true,
			// 	history:[
			// 		{userName:'1',message:'aloha, chat 2 here',date:'2019-6-1',type:'msg',errorMsg:false},
			// 		{userName:'2',message:'and',date:'2019-6-2',type:'msg',errorMsg:true},
			// 		{userName:'3',message:'die',date:'2019-6-3',type:'msg',errorMsg:false}
			// 	]
			// },
			// { 
			// 	cid: 3, 
			// 	title: 'try3',
			// 	lastestMessage: 'tryhard3: maybe',
			// 	updateDate: '4:19',
			// 	lastUpdateDatetime:'2019-05-25 16:36:13',
			// 	messageCount: 30,
			// 	muted: false,
			// 	history:[
			// 		{userName:'5',message:'bonjo, this is chat 3',date:'2019-6-1',type:'msg',errorMsg:true},
			// 		{userName:'6',message:'and',date:'2019-6-2',type:'msg',errorMsg:false},
			// 		{message:'wassup',date:'2019-6-3',type:'userMsg',errorMsg:true},
			// 		{userName:'3',message:'die',date:'2019-6-4',type:'msg',errorMsg:false},
			// 		{message:'not today',date:'2019-6-5',type:'userMsg',errorMsg:false},
			// 		{userName:'7',message:'die w/ glory',date:'2019-6-6',type:'msg',errorMsg:true},
			// 		{message:'showcase',date:'2019-6-7',type:'sysNoti',errorMsg:false}
			// 	]
			// }
		],
		contactIndex:[],
		contacts: [
			// { 
			// 		uid: 1, 
			// 		name: 'try1',
			//  	des:'smart ass'
			// }
		],
		// contactsQuick:{},
		cachedUser:{
			// 1:{ 
			// 		uid: 1, 
			// 		name: 'try1',
			//  	des:'smart ass'
			// }
		},
		contactRef:{
			// 1: 'try1'
		},
		contactRefTrace:0
	},
	mutations: {
		changeStatus(state,payload){
			state.status=payload.newStatus;
		},
		changeUserStatus(state,payload){
			state.userStatus=payload.newStatus;
		},
		login(state,payload){
			state.userName=(payload.userName != '' && payload.userName)?payload.userName:state.userName;
			state.userMail=(payload.userMail != '' && payload.userMail)?payload.userMail:state.userMail;
			state.userPasswd=(payload.userPasswd != '' && payload.userPasswd)?payload.userPasswd:state.userPasswd;
			state.UID=(payload.UID != '' && payload.UID)?payload.UID:state.UID;
		},
		logout(state){
			state.userName='';
			state.userMail='';
			state.userPasswd='';	
			state.userStatus='offline';
			state.UID=0;
			state.chats=[];
			state.contactIndex=[];
			state.contacts=[];
			state.cachedUser=[];
		},
		// Update history in chats, if does not exist then ignore.
		// payload: userName,message,cid,type,errorMsg
		updateChat(state,payload){
			let newHistoryItem = Object.assign({},payload);
			delete newHistoryItem['cid'];
			// Add history to different chathistory, if corresponding chathistory does not exist then ignore.
			if(payload.groupIndex){
				let groupIndex=payload.groupIndex;
				delete newHistoryItem['groupIndex'];
				state.chats[groupIndex].history.push(newHistoryItem);
			}else {
				state.chats=state.chats.map(obj => {
					if(obj.cid === payload.cid){
						obj.history.push(newHistoryItem);
					}
					return obj
				})
			}
		},
		updateGroup(state,payload){
			// If chat already exists, then update its lastestMessage,updateDate and lastUpdateDatetime. If new then add to chats.
			let groupExist=false;
			let payloadCounter=0;
			while(payload[payloadCounter]){
				let lastestMessage=JSON.parse(payload[payloadCounter].lastestMessage);
				if(state.chats.length != 0){
					let counter=0;
					while(counter<state.chats.length){
						if(state.chats[counter].cid == payload[payloadCounter].cid){
							groupExist=true;
							state.chats[counter].des=payload[payloadCounter].des;
							state.chats[counter].title=payload[payloadCounter].title;
							state.chats[counter].lastestMessage=lastestMessage.content;
							state.chats[counter].checkin=payload[payloadCounter].checkin;

							let date = new Date(lastestMessage.date);
							date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
							let result='';
							result=date.getFullYear().toString()+'-';
							if((date.getMonth()+1).toString().length==1)result+='0';
							result+=(date.getMonth()+1).toString()+'-';
							if(date.getDate().toString().length==1)result+='0';
							result+=date.getDate().toString()+' ';
							if(date.getHours().toString().length==1)result+='0';
							result+=date.getHours().toString()+':';
							if(date.getMinutes().toString().length==1)result+='0';
							result+=date.getMinutes().toString()+':';
							if(date.getSeconds().toString().length==1)result+='0';
							result+=date.getSeconds().toString();
							// alert(result);

							if(payload[payloadCounter].p2p === 0){
								state.chats[counter].admin=payload[payloadCounter].admin;
							}

							state.chats[counter].updateDate=result.substr(-8,5);
							state.chats[counter].lastUpdateDatetime=lastestMessage.date;
							// state.chats[counter].messageCount++;
						}
						counter++;
					}
				}
				if(!groupExist){
					let newGroup = {};
					newGroup.cid = payload[payloadCounter].cid;
					newGroup.des=payload[payloadCounter].des;
					newGroup.title=payload[payloadCounter].title;
					newGroup.checkin=payload[payloadCounter].checkin;
					newGroup.lastestMessage=lastestMessage.content;
					
					let date = new Date(lastestMessage.date);
					date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
					let result='';
					result=date.getFullYear().toString()+'-';
					if((date.getMonth()+1).toString().length==1)result+='0';
					result+=(date.getMonth()+1).toString()+'-';
					if(date.getDate().toString().length==1)result+='0';
					result+=date.getDate().toString()+' ';
					if(date.getHours().toString().length==1)result+='0';
					result+=date.getHours().toString()+':';
					if(date.getMinutes().toString().length==1)result+='0';
					result+=date.getMinutes().toString()+':';
					if(date.getSeconds().toString().length==1)result+='0';
					result+=date.getSeconds().toString();
					// alert(result);

					newGroup.updateDate=result.substr(-8,5);
					newGroup.lastUpdateDatetime=''; // lastestMessage.date it's useless to initialize such prop when first created
					newGroup.messageCount=0;
					newGroup.muted=false;
					newGroup.history=[];
					newGroup.p2p=payload[payloadCounter].p2p;
					if(payload[payloadCounter].p2p === 1){
						newGroup.peer1=payload[payloadCounter].peer1;
						newGroup.peer2=payload[payloadCounter].peer2;
					}else{
						newGroup.admin=payload[payloadCounter].admin;
					}
					state.chats.push(newGroup);
				}
				payloadCounter++;
			}
		},
		deleteGroup(state,payload){
			state.chats=state.chats.filter(obj => obj.cid !== payload.cid);
		},
		partialUpdateGroup(state,payload){
			state.chats=state.chats.map(chat => {
				if(chat.cid === parseInt(payload.cid)){
					chat.title=(payload.title.trim() !=='')?payload.title:chat.title;
					chat.des=(payload.des.trim() !=='')?payload.des:chat.des;
				}
				return chat
			})
		},
		syncHistory(state,payload){
			// Push new messages to chats[target].history , if corresponding chat does not exist, then ignore.
			let cid=payload[0].cid;
			let newHistory = [...payload];// Object.assign({},payload);
			if(newHistory != {}){
				let newHistoryArray=[];
				newHistoryArray=newHistory.map(msg => {
					delete msg['cid'];
					return msg
				})
				state.chats=state.chats.map(obj => {
					if(obj.cid === parseInt(cid)){
						obj.history=obj.history.concat(newHistoryArray);
						let last=newHistoryArray.length-1;
						obj.lastestMessage=newHistoryArray[last].userName+": "+newHistoryArray[last].message;
						let newDate=new Date(newHistoryArray[last].date);
						// newDate = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000));
						let string='';
						if(newDate.getHours().toString().length==1)string+='0';
						string+=newDate.getHours().toString()+':';
						if(newDate.getMinutes().toString().length==1)string+='0';
						string+=newDate.getMinutes().toString();
						obj.updateDate=string;
						obj.lastUpdateDatetime=newHistoryArray[last].date;
					}
					return obj
				})
			}
		},
		updateLastestMessage(state,payload){
			let counter=0;
			while(counter<state.chats.length){
				if(state.chats[counter].cid === parseInt(payload.cid)){
					state.chats[counter].lastestMessage=payload.msg;

					let date = new Date(payload.date);
					date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
					let result='';
					result=date.getFullYear().toString()+'-';
					if((date.getMonth()+1).toString().length==1)result+='0';
					result+=(date.getMonth()+1).toString()+'-';
					if(date.getDate().toString().length==1)result+='0';
					result+=date.getDate().toString()+' ';
					if(date.getHours().toString().length==1)result+='0';
					result+=date.getHours().toString()+':';
					if(date.getMinutes().toString().length==1)result+='0';
					result+=date.getMinutes().toString()+':';
					if(date.getSeconds().toString().length==1)result+='0';
					result+=date.getSeconds().toString();
					// alert(result);

					state.chats[counter].updateDate=result.substr(-8,5);
					if(!payload.localMsg && payload.atHomePage){
						state.chats[counter].messageCount++;
					}
					break;
				}
				counter++;
			}
		},
		initContacts(state,payload){
			if(payload.index){
				state.contactIndex=payload.index;
			}
			if(payload.contacts){
				state.contacts=payload.contacts;
				// payload.contacts.map(obj => state.contactsQuick[obj.uid]=obj);
			}
		},
		addContacts(state,payload){
			state.contactIndex.push(payload.userInfo.uid);
			state.contacts.push(payload.userInfo);
			// state.contactsQuick[payload.uid]=payload;
		},
		cacheUser(state,payload){
			for(let element of payload){
				state.cachedUser[element.uid]=element;
			}
		},
		deleteContact(state,payload){
			state.contactIndex=state.contactIndex.filter(uid => uid !== payload.uid);
			state.contacts=state.contacts.filter(obj => obj.uid !== payload.uid);
			state.chats=state.chats.filter(chat => {
				if(chat.p2p === 1){
					return (chat.peer1 === payload.uid || chat.peer2 === payload.uid)?false:true;
				}else{
					return true
				}
				
			});
		},
		updateMsgCount(state,payload){
			// Find corresponding chat element with cid and add message count.
			if(state.chats.length !== 0){
				let counter=0;
				while(counter<state.chats.length){
					if(state.chats[counter].cid === parseInt(payload.cid)){
						state.chats[counter].messageCount += payload.addCount;
						break;
					}
					counter++;
				}
			}
		},
		confirmSend(state,payload){
			state.chats=state.chats.map(obj => {
				if(payload.cid === obj.cid){
					let i=obj.history.length-1;
					while(i>=0){
						if(obj.history[i].uuid === payload.uuid){
							obj.history[i].success=true;
							break;
						}
						i--;
					}
				}
				return obj
			})
		},
		refresh(state,payload){
			state.chats=state.chats.filter(obj => {
				payload.group.indexOf(obj.cid) !== -1 
			})
			state.contacts=state.contacts.filter(obj => {
				payload.contact.indexOf(obj.uid) !== -1 
			})
			state.cachedUser={};
			state.contactRef={};
		},
		updateCheckin(state,payload){
			state.chats=state.chats.map(obj => {
				if(payload.cid === obj.cid){
					obj.checkin=payload.checkin;
				}
				return obj
			})
		}
	}
})
